var exports = {
  "CT": "DiscoverySkeleton.module__navList___RWF6RF",
  "pc": "DiscoverySkeleton.module__navItem___RWF6RF",
  "HW": "DiscoverySkeleton.module__navItemActive___RWF6RF",
  "hk": "DiscoverySkeleton.module__navItemLabel___RWF6RF",
  "kL": "DiscoverySkeleton.module__container___RWF6RF",
  "v_": "DiscoverySkeleton.module__navbar___RWF6RF",
  "$L": "DiscoverySkeleton.module__categoryTabs___RWF6RF",
  "VJ": "DiscoverySkeleton.module__navbarSearch___RWF6RF",
  "Gm": "DiscoverySkeleton.module__scrollBody___RWF6RF",
  "Qs": "DiscoverySkeleton.module__content___RWF6RF",
  "Vg": "DiscoverySkeleton.module__grid___RWF6RF",
  "Nr": "DiscoverySkeleton.module__card___RWF6RF",
  "zl": "DiscoverySkeleton.module__cardBanner___RWF6RF",
  "Ie": "DiscoverySkeleton.module__cardIcon___RWF6RF",
  "zI": "DiscoverySkeleton.module__cardBody___RWF6RF",
  "JJ": "DiscoverySkeleton.module__cardTitle___RWF6RF",
  "L_": "DiscoverySkeleton.module__cardDescription___RWF6RF",
  "UX": "DiscoverySkeleton.module__cardFooter___RWF6RF",
  "Kd": "DiscoverySkeleton.module__cardStats___RWF6RF",
  "Ne": "DiscoverySkeleton.module__cardStat___RWF6RF",
};

module.exports = exports;
